const DEFAULT_SCENE = 'administration:my-agents';
const LIST_OF_AGENTS = `${DEFAULT_SCENE}:list-of-agents`;
const HEADER_SEARCH_AGENTS = `${DEFAULT_SCENE}:filter-agent`;
const EDIT_AGENT = `${DEFAULT_SCENE}:edit-agent`;

// AgentsScene
export const CONTAINER_TAG = `${DEFAULT_SCENE}:container`;
export const TITLE_TAG = `${DEFAULT_SCENE}:title`;

// AgentsList
export const LIST_OF_AGENTS_CONTAINER_TAG = `${LIST_OF_AGENTS}:container`;
export const getAgentPropTag = (propName: string) => `${LIST_OF_AGENTS}:agent-${propName}`;

// Header SearchAgents
export const SEARCH_AGENTS_CONTAINER_TAG = `${HEADER_SEARCH_AGENTS}:container`;
export const SEARCH_AGENTS_SUBMIT_BUTTON_TAG = `${HEADER_SEARCH_AGENTS}:button-submit`;

// SideBar Filter
const FILTER_SIDEBAR = `${DEFAULT_SCENE}:filter-sidebar`;
export const TOGGLE_FILTER_BUTTON_TAG = `${FILTER_SIDEBAR}:button-toggle`;
export const APPLY_FILTER_BUTTON_TAG = `${FILTER_SIDEBAR}:button-apply`;
export const FILTER_SIDEBAR_DROPDOWN_TOGGLE = `${FILTER_SIDEBAR}:dropdown-toggle`;
export const RESET_ALL_SIDEBAR_FILTERS_BUTTON_TAG = `${FILTER_SIDEBAR}:reset-all-filters`;
export const ACTIVE_SIDEBAR_FILTERS_COUNTER = `${FILTER_SIDEBAR}:active-filters-counter`;

// EditAgent
export const EDIT_AGENT_TITLE_TAG = `${EDIT_AGENT}:title`;
export const EDIT_AGENT_SUBMIT_BUTTON_TAG = `${EDIT_AGENT}:button-submit`;
export const EDIT_AGENT_CANCEL_BUTTON_TAG = `${EDIT_AGENT}:button-cancel`;
export const EDIT_AGENT_INPUT_FIELD = `${EDIT_AGENT}:text-input`;
